import { render, staticRenderFns } from "./DatiCheckIn.vue?vue&type=template&id=1f2f9610&scoped=true&"
import script from "./DatiCheckIn.vue?vue&type=script&lang=js&"
export * from "./DatiCheckIn.vue?vue&type=script&lang=js&"
import style0 from "./DatiCheckIn.vue?vue&type=style&index=0&id=1f2f9610&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2f9610",
  null
  
)

export default component.exports